import React, { memo } from 'react';
import { IconButton } from '@material-ui/core';
import PropTypes from 'prop-types';
import DoubleArrow from '../../../../icons/DoubleArrow';

const DoubleArrowIcon = ({ down }) => (
  <IconButton>
    <DoubleArrow width={17} height={19} down={down} />
  </IconButton>
);

DoubleArrowIcon.propTypes = {
  down: PropTypes.bool,
};

DoubleArrowIcon.defaultProps = {
  down: false,
};

export default memo(DoubleArrowIcon);
